import gql from "graphql-tag";

export const ADD_PAVING_SUPER = gql`
  mutation addPavingSuper($where: AddPavingSuperInput!){
    addPavingSuper(where: $where)
  }
`;